var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component"},'component',Object.assign({}, _vm.$attrs,
    {disabled: _vm.disabled,
    type: _vm.type,
    class: _vm.classNames}),false),[_vm._t("default",[(_vm.labelComp)?_c('span',{staticClass:"elder-button__label"},[_vm._v(" "+_vm._s(_vm.labelComp)+" ")]):_vm._e(),(_vm.iconComp)?_c('span',{staticClass:"elder-button__icon"},[_c('font-awesome-icon',_vm._b({},'font-awesome-icon',_vm.iconComp,false))],1):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }